import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
const HomePage = () => import('../views/HomePage')


const router = new VueRouter(
  {
    mode: 'history',
    base: __dirname,
    routes: [{
        path: '/',
        component: HomePage
      },
      {
        path: 'about/',
        name: 'about',
        // route level code-splitting
        // this generates a separate chunk (About.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import('../views/AboutPage'),
        meta: {
          title: '關於我們'
        }
      },
      {
        path: 'sell',
        name: 'sell',
        // route level code-splitting
        // this generates a separate chunk (About.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import('../views/SellPage'),
        meta: {
          title: '服務範圍'
        }
      },
      {
        path: 'dujia',
        name: 'dujia',
        // route level code-splitting
        // this generates a separate chunk (About.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import('../views/DuJiaPage'),
        meta: {
          title: '獨家專區'
        }
      },
      {
        path: 'sellView',
        name: 'sellView',
        // route level code-splitting
        // this generates a separate chunk (About.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import('../views/SellView'),
        meta: {
          title: '詳情'
        }
      },
      {
        path: 'property',
        name: 'property',
        // route level code-splitting
        // this generates a separate chunk (About.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import('../views/PropertyPage'),
        meta: {
          title: '物業委託'
        }
      },
      {
        path: 'contact',
        name: 'contact',
        // route level code-splitting
        // this generates a separate chunk (About.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import('../views/ContactPage'),
        meta: {
          title: '聯繫我們'
        }
      },
      {
        path: 'calc',
        name: 'calc',
        // route level code-splitting
        // this generates a separate chunk (About.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import('../views/CalcPage'),
        meta: {
          title: '房贷计算器'
        }
      }
    ]
  }
);


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js